import Accordions from '@/components/sections/Accordions'
import ArchiveGrid from '@/components/sections/ArchiveGrid'
import ArchivePostTypes from '@/components/sections/ArchivePostTypes'
import ContactForm from '@/components/sections/ContactForm'
import DoubleBanner from '@/components/sections/DoubleBanner'
import DoubleText from '@/components/sections/DoubleText'
import Filters from '@/components/sections/Filters'
import FullImage from '@/components/sections/FullImage'
import FullParagraph from '@/components/sections/FullParagraph'
import Gallery from '@/components/sections/Gallery'
import HalfParagraph from '@/components/sections/HalfParagraph'
import Hero from '@/components/sections/Hero'
import ImageCardGrid from '@/components/sections/ImageCardGrid'
import IndexParagraph from '@/components/sections/IndexParagraph'
import LoadMore from '@/components/sections/LoadMore'
import LogoWall from '@/components/sections/LogoWall'
import Map from '@/components/sections/Map'
import Media from '@/components/sections/Media'
import Numbers from '@/components/sections/Numbers'
import PillarsGrid from '@/components/sections/PillarsGrid'
import PillarsGridIcon from '@/components/sections/PillarsGridIcon'
import ProjectGrid from '@/components/sections/ProjectGrid'
import PushParagraph from '@/components/sections/PushParagraph'
import Slider from '@/components/sections/Slider'
import Spacer from '@/components/sections/Spacer'
import TabsInfo from '@/components/sections/TabsInfo'
import TextOnImage from '@/components/sections/TextOnImage'
import Timeline from '@/components/sections/Timeline'

export const sectionsMap: any = {
  accordions: Accordions,
  archive_grid: ArchiveGrid,
  archive_post_types: ArchivePostTypes,
  contact_form: ContactForm,
  double_banner: DoubleBanner,
  double_text: DoubleText,
  filters: Filters,
  full_image: FullImage,
  full_paragraph: FullParagraph,
  gallery: Gallery,
  half_paragraph: HalfParagraph,
  hero: Hero,
  image_card_grid: ImageCardGrid,
  index_paragraph: IndexParagraph,
  load_more: LoadMore,
  logo_wall: LogoWall,
  map: Map,
  media: Media,
  numbers: Numbers,
  pillars_grid: PillarsGrid,
  pillars_grid_icon: PillarsGridIcon,
  project_grid: ProjectGrid,
  push_paragraph: PushParagraph,
  slider: Slider,
  spacer: Spacer,
  tabs_info: TabsInfo,
  text_on_image: TextOnImage,
  timeline: Timeline
}
